import React, { useCallback, useMemo, useState, useEffect, useRef, CSSProperties } from "react";
import {
  Box,
  Fade,
  FormGroup,
  FormControl,
  FormControlLabel,
  Grid,
  IconButton,
  Stack,
  Switch,
  Typography,
  useTheme,
} from "@mui/material";
import { ArrowBackIosNew } from "@mui/icons-material";
import { useLocation, useNavigate } from "react-router-dom";
import { BrowserView, MobileView, isBrowser, isMobile } from "react-device-detect";
import { formatTime, getAdaptivFontSize, getRoute } from "../utils/CommonUtils";
import { ScoreComponent } from "./score-component";
import { AppSingleton } from "../services/user_config";
import { BounceLoader } from "react-spinners";
import { getOrientation } from "../utils/CommonUtils";

const ServerPlayer = ({ url, tutorialVideoRef, isReadyRef, speed }) => {
  const [maxVideoSize, setMaxVideoSize] = useState({
    width: window.screen.width || 0,
    height: window.screen.height || 0,
  });
  // const [tutorialVideoAutoPlay, setTutorialVideoAutoPlay] = useState(false);
  const appSingleton = new AppSingleton();
  const theme = useTheme();
  const contentColor = appSingleton.isDarkMode ? "white" : "black";
  // const backgroundColor = appSingleton.isDarkMode ? "black" : "white";
  const backgroundColor = appSingleton.isDarkMode ? "transparent" : "transparent";
  const [startedPlaying, setStartedPlaying] = useState(false);
  const [isSpeedHintVisible, setIsSpeedHintVisible] = useState(false);
  const [orientation, setOrientation] = useState(getOrientation()); // MARK: portrait, landscape
  const [bottomMargin, setBottomMargin] = useState(getOrientation() === "landscape" ? 90 : 180); // MARK: portrait, landscape

  // const handleLoadedMetadata = () => {
  //   onScreenResize();
  // };

  // useEffect(() => {
  //   console.log(`player: ${orientation}`);
  //   const video = tutorialVideoRef.current;
  //   console.log(video);
  //   // if (video) {
  //   //   if (orientation === "landscape") {
  //   //     video.style.objectFit = "contain";
  //   //     video.style.top = "0px";
  //   //     video.style.bottom = "none";
  //   //     video.style.width = "60%";
  //   //   }
  //   //   if (orientation === "portrait") {
  //   //     video.style.objectFit = "cover";
  //   //     video.style.top = "none";
  //   //     video.style.bottom = `${180 + 16 + 24}px`;
  //   //     video.style.width = "100%";
  //   //   }
  //   // }
  // }, [orientation, tutorialVideoRef]);

  const onScreenResize = () => {
    setOrientation(getOrientation());
    const screenWidth = window.innerWidth; // Width of the screen
    const screenHeight = window.innerHeight - (getOrientation() === "landscape" ? 90 : 180); // Height of the screen

    // const videoWidth = videoRef.current.videoWidth; // Width of the video
    // const videoHeight = videoRef.current.videoHeight; // Height of the video
    // let widthUpScale = screenWidth / videoHeight;
    // let heightUpScale = screenHeight / videoHeight;
    // const upScale = Math.max(widthUpScale, heightUpScale);
    // console.log(`screen width: ${screenWidth}; screen height: ${screenHeight}`);
    // console.log(`video width: ${videoWidth}; video height: ${videoHeight}`);
    // MARK: Rule 1 => video height at least reach the screen height
    // MARK: Rule 2 => video width at least react the screen height

    setMaxVideoSize({
      // maxWidth: window.screen.availWidth,
      // maxHeight: window.screen.availHeight,
      width: screenWidth,
      height: screenHeight,
    });
  };

  // const onScreenResize = () => {
  //   const screenWidth = window.innerWidth; // Width of the screen
  //   const screenHeight = window.innerHeight; // Height of the screen
  //   console.log(`screen width: ${screenWidth}; screen height: ${screenHeight}`);
  //   const videoWidth = videoRef.current.videoWidth; // Width of the video
  //   const videoHeight = videoRef.current.videoHeight; // Height of the video
  //   console.log(`video width: ${videoWidth}; video height: ${videoHeight}`);
  //   const screenRatio = screenWidth / screenHeight;
  //   const videoRatio = videoWidth / videoHeight;
  //   setAspectFillSize({
  //     // maxWidth: window.screen.availWidth,
  //     // maxHeight: window.screen.availHeight,
  //     width: screenRatio < videoRatio ? "auto" : screenWidth,
  //     height: screenRatio < videoRatio ? screenHeight : "auto",
  //   });
  // };

  useEffect(() => {
    window.addEventListener("resize", onScreenResize);
    const video = tutorialVideoRef.current;
    video.addEventListener("canplay", (_video) => {
      // setTutorialVideoAutoPlay(false);
    });
    // tutorialVideoRef.current.addEventListener("loadedmetadata", () => {
    //   handleLoadedMetadata();
    // });
    return () => {
      window.removeEventListener("resize", onScreenResize);
    };
  }, []);

  useEffect(() => {
    const intervalId = setInterval(() => {
      if (isReadyRef.current) {
        tutorialVideoRef.current.play();
        setStartedPlaying(true);
        clearInterval(intervalId);
      }
    }, 200);
    return () => {
      clearInterval(intervalId);
    };
  }, []);

  useEffect(() => {
    const video = tutorialVideoRef.current;
    if (video) {
      video.playbackRate = speed;
      setIsSpeedHintVisible(true);
      setTimeout(() => {
        setIsSpeedHintVisible(false);
      }, 1000);
    }
  }, [speed, tutorialVideoRef]);

  // const fadeOut = useCallback(() => {
  //   setTimeout(() => {
  //     setIsSpeedHintVisible(false);
  //   }, 1000);
  // });

  return (
    <Box
      sx={{
        // position: "relative",
        width: "100vw",
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        overflow: "hidden",
        backgroundColor: "transparent",
      }}
    >
      <video
        id="server-player-video"
        ref={tutorialVideoRef}
        src={url}
        // controls
        // muted
        playsInline
        // loop
        preload="metadata"
        maxWidth="100%"
        // maxHeight={`${maxVideoSize.height}px`}
        style={{
          position: "absolute",
          // top: orientation === "landscape" ? "-120px" : "",
          bottom: `${(orientation === "landscape" ? 90 : 180) + 16 + 24}px`, // orientation === "landscape" ? "" : `${180 + 16 + 24}px`,
          width: orientation === "landscape" ? "100%" : "100%",
          height: orientation === "landscape" ? `${maxVideoSize.height}px` : "auto",
          objectFit: orientation === "landscape" ? "cover" : "contain",
          // height: "auto",
          // margin: "0 auto",
          backgroundColor,
        }}
      />
      {!startedPlaying ? (
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: theme.palette.background.main,
          }}
        >
          <Stack direction="column" spacing={1} sx={{ alignItems: "center" }}>
            <Typography
              sx={{
                fontSize: getAdaptivFontSize(window.screen.width < 768 ? getAdaptivFontSize(12) : getAdaptivFontSize(14)),
              }}
            >
              運動前應伸展肩頸及上肢
            </Typography>
            <Typography
              sx={{ fontSize: getAdaptivFontSize(window.screen.width < 768 ? getAdaptivFontSize(12) : getAdaptivFontSize(14)) }}
            >
              運動時有可能感到肩部肌肉疲倦，但不應有痛楚
            </Typography>
            <Typography
              sx={{ fontSize: getAdaptivFontSize(window.screen.width < 768 ? getAdaptivFontSize(12) : getAdaptivFontSize(14)) }}
            >
              運動時如有不適，包括呼吸不暢、胸部不適、頭暈/ 頭痛、噁心等，應立刻停止，需要時求診
            </Typography>
            <Typography
              sx={{ fontSize: getAdaptivFontSize(window.screen.width < 768 ? getAdaptivFontSize(12) : getAdaptivFontSize(14)) }}
            >
              請量力而為，不應勉強
            </Typography>
          </Stack>
        </Box>
      ) : null}

      <Fade in={isSpeedHintVisible} {...{ timeout: 500 }}>
        <img
          src={`/img/${speed === 1.0 ? "rabbit" : "turtle"}.png`}
          style={{ position: "absolute", top: 16, left: "50%", transform: "translateX(-50%)", width: "64px", height: "64px" }}
          alt={`${speed}`}
        />
      </Fade>

      <BounceLoader
        color="white"
        loading={!startedPlaying}
        cssOverride={{ display: "block", margin: "0 auto", borderColor: "red" }}
        size={150}
        aria-label="Loading Spinner"
        data-testid="loader"
      />
    </Box>
  );
};

const PlayerControllerComponent = ({
  tutorialVideoRef,
  gestureStatusRef,
  scoreRef,
  exercise_id,
  title,
  subtitle,
  trainer,
  videoUrl,
  onComplete,
  isReadyRef,
}) => {
  const navigate = useNavigate();
  const appSingleton = new AppSingleton();
  const theme = useTheme();

  const [videoDuration, setVideoDuration] = useState(0);
  const [videoCurrentTime, setVideoCurrentTime] = useState(0);
  const [speed, setSpeed] = useState(1.0);
  const accuracyRef = useRef(0);
  // const scoreRef = useRef(0);

  // const contentColor = appSingleton.isDarkMode ? "white" : "black";
  // const backgroundColor = appSingleton.isDarkMode ? "black" : "white";

  const handleLoadedMetadata = (_video) => {
    if (_video.duration > 0) {
      setVideoDuration(_video.duration);
    }
  };

  const handleTimeUpdate = (_video) => {
    setVideoCurrentTime(_video.currentTime);
    try {
      if (_video.duration > 0) {
        setVideoDuration(_video.duration);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleReady = (_video) => {
    // MARK: Should be able to autoPlay when set muted, but just to be safe, to play it programatically
    // _video.play();
  };

  const handleVideoEnd = (_video) => {
    // _video.play();
    console.log("Completed");
    const totalScore = Object.values(scoreRef.current).reduce((acc, val) => acc + val, 0);
    onComplete({ score: totalScore, accuracy: accuracyRef.current });
  };

  useEffect(() => {
    const video = document.getElementById("server-player-video");
    video.addEventListener("loadedmetadata", () => {
      handleLoadedMetadata(video);
    });
    video.addEventListener("timeupdate", () => {
      handleTimeUpdate(video);
    });
    video.addEventListener("canplay", () => {
      handleReady(video);
    });
    video.addEventListener("ended", handleVideoEnd);

    return () => {
      video.removeEventListener("loadedmetadata", handleLoadedMetadata);
      video.removeEventListener("timeupdate", handleTimeUpdate);
      video.removeEventListener("canplay", handleReady);
      video.removeEventListener("ended", handleVideoEnd);
    };
  }, []);

  return (
    <Box>
      <Box>
        <Box sx={{ display: "flex", justifyContent: "center" }}>
          {/* <ServerPlayer url={`${httpEndpoint}/video/fitness-3min-white10.mp4`} tutorialVideoRef={tutorialVideoRef} /> */}
          <ServerPlayer url={videoUrl} tutorialVideoRef={tutorialVideoRef} isReadyRef={isReadyRef} speed={speed} />
        </Box>
        <Box sx={{ position: "absolute", left: 0, top: 0, width: "100%" }}>
          <Box sx={{ ml: 2 }}>
            <Grid container spacing={1} sx={{ display: "flex", justifyContent: "space-between" }}>
              <Grid item xs={8} sx={{ display: "flex", justifyContent: "flex-start" }}>
                <IconButton
                  onClick={() => {
                    navigate(`${getRoute("landing-page")}`);
                  }}
                >
                  <ArrowBackIosNew />
                </IconButton>
                <Typography
                  noWrap
                  color="primary"
                  sx={{
                    fontSize: getAdaptivFontSize(window.screen.width < 768 ? getAdaptivFontSize(28) : getAdaptivFontSize(48)),
                  }}
                >
                  {title}
                </Typography>
              </Grid>

              <Grid item xs={4} sx={{ display: "flex", alignItems: "center", justifyContent: "flex-end" }}>
                <Typography
                  noWrap
                  color="primary"
                  sx={{
                    fontSize: getAdaptivFontSize(window.screen.width < 768 ? getAdaptivFontSize(28) : getAdaptivFontSize(48)),
                  }}
                >
                  ⏱️{formatTime(videoDuration - videoCurrentTime)}
                </Typography>
              </Grid>
            </Grid>
            <Box sx={{ ml: 2 }}>
              <Typography
                color="primary"
                sx={{
                  pt: 0,
                  pb: 0,
                  fontSize: getAdaptivFontSize(window.screen.width < 768 ? getAdaptivFontSize(16) : getAdaptivFontSize(20)),
                }}
              >
                {subtitle}
              </Typography>

              <Typography
                color="primary"
                sx={{
                  pt: 0,
                  pb: 0,
                  fontSize: getAdaptivFontSize(window.screen.width < 768 ? getAdaptivFontSize(12) : getAdaptivFontSize(14)),
                }}
              >
                這些運動是依據一般體弱長者身體情況而制訂，所以過程中如有任何不適，應立刻停止，需要時向你的家庭醫生查詢。
              </Typography>

              <Typography
                color="primary"
                sx={{
                  pt: 0,
                  pb: 0,
                  fontSize: getAdaptivFontSize(window.screen.width < 768 ? getAdaptivFontSize(16) : getAdaptivFontSize(32)),
                }}
              >
                {trainer}
              </Typography>

              <FormGroup>
                <Stack direction="row" spacing={1} sx={{ alignItems: "center" }}>
                  <Typography
                    sx={{
                      fontSize: getAdaptivFontSize(window.screen.width < 768 ? getAdaptivFontSize(12) : getAdaptivFontSize(24)),
                    }}
                  >
                    慢速
                  </Typography>
                  <Switch
                    defaultChecked
                    checked={speed === 1.0}
                    onChange={(evt) => setSpeed(evt.target.checked ? 1.0 : 0.75)}
                  />
                  <Typography
                    sx={{
                      fontSize: getAdaptivFontSize(window.screen.width < 768 ? getAdaptivFontSize(12) : getAdaptivFontSize(24)),
                    }}
                  >
                    快速
                  </Typography>
                </Stack>
              </FormGroup>
            </Box>
          </Box>
        </Box>
      </Box>
      <Box
        sx={{
          position: "absolute",
          left: 0,
          bottom: 0,
          width: "100%",
          // height: "200px", // Adjust the height as per your requirement
        }}
      >
        <ScoreComponent
          videoDuration={videoDuration}
          videoCurrentTime={videoCurrentTime}
          gestureStatusRef={gestureStatusRef}
          scoreRef={scoreRef}
          backfeedScore={(_score) => {
            // scoreRef.current = _score;
          }}
          backfeedAccuracy={(_accuracy) => {
            accuracyRef.current = _accuracy;
          }}
          isReadyRef={isReadyRef}
        />
      </Box>
    </Box>
  );
};
export { PlayerControllerComponent };
